export default __webpack_public_path__ + "static/media/40.dcb1a462.jpg";